/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Faq_4_AnswerInputs */

const en_svc_n8n_faq_4_answer = /** @type {(inputs: Svc_N8n_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. n8n has AI steps for language models, and we use them to classify messages, extract data from documents and draft text, with an approval step wherever the output leaves the business.`)
};

const lv_svc_n8n_faq_4_answer = /** @type {(inputs: Svc_N8n_Faq_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jā. n8n ir AI soļi valodas modeļiem, un mēs tos izmantojam ziņu klasificēšanai, datu ieguvei no dokumentiem un tekstu sagatavošanai, ar apstiprināšanas soli visur, kur rezultāts iziet no uzņēmuma.`)
};

/**
* | output |
* | --- |
* | "Yes. n8n has AI steps for language models, and we use them to classify messages, extract data from documents and draft text, with an approval step wherever t..." |
*
* @param {Svc_N8n_Faq_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_faq_4_answer = /** @type {((inputs?: Svc_N8n_Faq_4_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Faq_4_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_faq_4_answer(inputs)
	return en_svc_n8n_faq_4_answer(inputs)
});